// Saving «Qué puede hacer» (pantallas-abilities-y-skills, D1).

import { agentsService } from '@/services/agentsService'

/** Saves what changed: the Abilities first -the server checks a Skill's agents
 *  have what it needs-, then each Skill this agent was added to or taken off. */
export async function saveCapabilities(
  agentId: string,
  next: { abilityIds: string[]; skillIds: string[] },
  saved: { abilityIds: string[]; skillIds: string[] },
) {
  const same = (a: string[], b: string[]) => a.length === b.length && a.every((x) => b.includes(x))
  if (!same(next.abilityIds, saved.abilityIds)) {
    await agentsService.setAgentAbilities(agentId, next.abilityIds)
  }
  const added = next.skillIds.filter((id) => !saved.skillIds.includes(id))
  const removed = saved.skillIds.filter((id) => !next.skillIds.includes(id))
  if (added.length === 0 && removed.length === 0) return
  const skills = await agentsService.listSkills()
  for (const skill of skills) {
    if (added.includes(skill.id)) {
      await agentsService.updateSkill(skill.id, { agent_ids: [...skill.agent_ids, agentId] })
    } else if (removed.includes(skill.id)) {
      await agentsService.updateSkill(skill.id, { agent_ids: skill.agent_ids.filter((id) => id !== agentId) })
    }
  }
}
